import { customerService } from '../services'
import Vue from 'vue'
import $axios from '@/axios-instance.js'

const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      name: null,
      orderByColumn: 'name',
      orderByDescending: false
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return customerService.getAll()
      .then(
        data => {
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    commit('getListDataRequest')
    return customerService.getListData(state.all.filter, state.all.currentPage)
      .then(data => {
        commit('getListDataSuccess', data.result)
        return data.result
      })
      .catch(error => {
        if ($axios.isCancel(error)) {
          console.info('Previous request cancelled')
        } else {
          console.error(error)
        }
      })
  },

  getById ({ commit }, id) {
    return customerService.getById(id)
  },

  create ({ commit, dispatch }, customer) {
    commit('startSave')
    return customerService.create(customer)
      .then(customer => {
        commit('endSave')
        commit('createSuccess', customer.result)
        dispatch('getListData')
        return customer.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, customer) {
    commit('startSave')
    return customerService.update(customer)
      .then(customer => {
        commit('endSave')
        commit('updateSuccess', customer.result)
        return customer
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)

    customerService.delete(id)
      .then(customer => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
      .catch(error => {
        commit('endSave')
        commit('deleteFailure', error)
        return Promise.reject(error)
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedcustomer) {
    Vue.prototype.$toast('Kund skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa kund', 'error')
  },

  // Update
  updateSuccess (state, updatedCustomer) {
    state.all.items = state.all.items.map(customer =>
      customer.customerId === updatedCustomer.customerId ? updatedCustomer : customer
    )

    Vue.prototype.$toast('Kund uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera kund', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to customer being deleted
    state.all.items = state.all.items.map(customer =>
      customer.customerId === id
        ? { ...customer, deleting: true }
        : customer
    )
  },
  deleteSuccess (state, id) {
    state.all.items = state.all.items.filter(customer => customer.customerId !== id)
  },
  deleteFailure (state, error) {
    Vue.prototype.$toast('Kunde inte ta bort kund', 'error')
  }
}

export const customers = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/customer.module.js